import { createContext, useContext } from "react";
import type { ComboBoxContext as ComboBoxContextType } from "./types";

const ComboBoxContext = createContext<ComboBoxContextType | undefined>(
  undefined,
);

export const ComboBoxProvider = ComboBoxContext.Provider;

export const useComboBoxContext = () => {
  const context = useContext(ComboBoxContext);
  if (!context) {
    throw new Error(
      "useComboBoxContext must be used within a ComboBoxProvider",
    );
  }
  return context;
};
